import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import ValidationErrorMessage from '../ssap/notifications/ValidationErrorMessage';

const AssisterFilter = props => {
    const {
        filterList,
        filterInputsMaxLength,
        labelNames,
        formName,
        handleChange,
        applyHandler,
        handleKeyPress        
    } = props;

    const filterInputs = Object.keys(filterList).map((filter, index) => {        
        switch(filterList[filter].type){
            case 'text':{
                return (
                    <div key={index} className="filter__form__input-wrapper grid-col-4">
                        <label 
                            className="usa-label gi-regular_input__label"
                            htmlFor={`input_${filter}`}>
                            {<FormattedMessage id={labelNames[filter]}/>}
                        </label>
                        <input
                            className="usa-input gi-input gi-regular_input__input text-left"
                            id={`input_${filter}`}
                            name={filter}
                            value={ filterList[filter].value }
                            onChange={handleChange}
                            maxLength={filterInputsMaxLength[filter]}
                            onKeyPress={handleKeyPress}
                        />
                        <ValidationErrorMessage
                            isVisible={filterList[filter].isVisible}
                            messageText={filterList[filter].message}
                            errorClasses={['margin-l-0']}
                        />
                        
                    </div>);
            }
            case 'dropdown':{
                return (
                    <Fragment>
                        <div key={index} className="filter__form__input-wrapper grid-col-4">
                            <label 
                                className="usa-label"
                                htmlFor={`input_${filter}`}>
                                {<FormattedMessage id={labelNames[filter]}/>}
                            </label>
                            {
                                <select value={filterList[filter].value} onChange={handleChange} name={filter} className="usa-select gi-input text-left-i gi-dropdown__select">
                                    <option value="">Select One</option>
                                    { filterList[filter].values.map(opt =>  {
                                        return (
                                            <option key={opt.value} value={opt.value}>{opt.text}</option>
                                        );
                                    }) }
                                </select>                        
                            }
                            
                        </div>
                        <br clear="all"/>
                    </Fragment>);
            }    
        }        
    });

    return (
        <form name={formName} className="filter__form" onSubmit={(e) => e.preventDefault()}>
            <div className="filter__form-filters">
                {filterInputs}
            </div>
            <div className='filter__form-controls' >
                <button
                    type="button"
                    className='usa-button gi-button gi-button__primary'
                    onClick={applyHandler}
                >
                    <FormattedMessage id="common.search"/>
                </button>
            </div>
        </form>
    );
};

export default AssisterFilter;